import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { _ApplyPromoCode } from '@Services/Checkout';
import Check from 'public/white_icon.svg';
import send from 'public/send.svg';
import React, { Fragment, useState } from 'react';
import { Controller, SubmitHandler, useForm, UseFormSetError } from 'react-hook-form';
import { CouponFormWrapper, CouponInput, CouponTitle, SubmitCouponForm } from './CheckoutView.styled';
import { useDispatch } from 'react-redux';

type Props = {};
type CouponForm02 = {
  coupon: string;
};
export default function CouponForm({}: Props) {
  const { t } = useTranslation('Checkout');
  const { checkout: checkoutModel } = useDispatch();
  const [isvaild, setIsvaild] = useState('');
  const [textError, setTextError] = useState(t('couponIsUnvaild'));
  const [valueCoupon, setvalueCoupon] = useState<any>(null);
  const {
    register,
    setValue,
    control,
    watch,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<CouponForm02>();
  const onSubmit: SubmitHandler<CouponForm02> = async (data) => {
    // console.log(data);
    // console.log(type);
    let newCheckoutData;
    if (data != null) {
      let { coupon } = data;
      newCheckoutData = await _ApplyPromoCode(coupon);
    }
    // console.log('============================');
    // console.log(newCheckoutData);
    if (newCheckoutData && newCheckoutData.response && newCheckoutData.response.status == 404 ||
      newCheckoutData && newCheckoutData.response && newCheckoutData.response.status == 400 ||
        newCheckoutData && newCheckoutData.response && newCheckoutData.response.status == 500) {
      setIsvaild('false');
      console.log(newCheckoutData.response.data.message);
      if(newCheckoutData && newCheckoutData.response && newCheckoutData.response.status == 400){
        setTextError(newCheckoutData.response.data.message);
      } else {
        setTextError(t('couponIsUnvaild'));
      }
      if (valueCoupon != null) {
        let returnedTarget = Object.assign({}, valueCoupon);
        
        // console.log(returnedTarget.total_price);
        returnedTarget.total_price = Object.assign({}, valueCoupon.total_price);
        returnedTarget.total_price['total_discount'] = 0;
        returnedTarget.total_price['total_price'] = returnedTarget.total_price['total_items_price'];
        // console.log(returnedTarget['total_price']['total_discount']);
        // returnedTarget['total_price'] = 0
        // console.log(returnedTarget);
        checkoutModel.setCheckoutData(returnedTarget);
      }
    } else {
      setIsvaild('true');
      setvalueCoupon({ ...newCheckoutData });
      // console.log('============================');
      // console.log(newCheckoutData);
      checkoutModel.setCheckoutData(newCheckoutData);
    }
  };
  return (
    <Fragment>
      <CouponTitle>{t('coupon')}</CouponTitle>
      <CouponFormWrapper
        className={isvaild == 'true' ? 'contentIsVaild' : isvaild == 'false' ? 'contentUnVaild' : ''}
        onSubmit={handleSubmit((data) => onSubmit(data))}
      >
        <CouponInput
          maxLength={25}
          onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if ((e.target as HTMLInputElement).value == '') {
              setIsvaild('');
            }
          }}
          {...register('coupon', { required: true })}
          type="text"
          placeholder={t('couponPlaseholder')}
        />
        {isvaild == 'true' ? (
          <SubmitCouponForm>
            <Image src={Check} width={14.76} height={11} alt="check" />
          </SubmitCouponForm>
        ) : (
          <SubmitCouponForm>
            <Image src={send} width={14.76} height={11} alt="check" />
          </SubmitCouponForm>
        )}
      </CouponFormWrapper>
      {isvaild == 'false' && <p className="textCoupon">{textError}</p>}
    </Fragment>
  );
}
